import { BrandType } from './brand'
import { getUrlParam } from './url-param'

type Link = 'impressum' | 'kuendigen' | 'agb' | 'datenschutz'
type LinkMap = Record<Link, string>

const linksMap: Record<BrandType, LinkMap> = {
  'gmx.net': {
    impressum: 'https://www.gmx.net/impressum/',
    kuendigen: 'https://www.gmx.net/kuendigungsformular/',
    agb: 'https://agb-server.gmx.net/gmxagb-de/',
    datenschutz: 'https://agb-server.gmx.net/datenschutz/'
  },
  'gmx.at': {
    impressum: 'https://www.gmx.at/impressum/',
    kuendigen: 'https://www.gmx.net/kuendigungsformular/',
    agb: 'https://www.gmx.at/impressum/',
    datenschutz: 'https://agb-server.gmx.net/datenschutz-at'
  },
  'web.de': {
    impressum: 'https://web.de/impressum/',
    kuendigen: 'https://web.de/kuendigungsformular/',
    agb: 'https://agb-server.web.de/webdeagb/',
    datenschutz: 'https://agb-server.web.de/datenschutz/'
  }
}

export function applyBrandStyles(brand: BrandType): void {
  const isGmx = brand.indexOf('gmx') === 0
  document.documentElement.classList.add(isGmx ? 'gmx' : 'webde')
  const portal = getUrlParam('portal')

  if (brand === 'gmx.at' || portal === 'gmxat') {
    document.documentElement.classList.add('gmxat')
  }

  const luxBrand = isGmx ? 'gmx_net' : 'web_de'
  const styleHref = `https://s.uicdn.com/fd-cdn/lux/build/css/${luxBrand}.css`
  document.querySelector('[data-replace-href=brand-css]').setAttribute('href', styleHref)

  if (isGmx) {
    document.querySelector('[data-replace-inner-html=logo]').innerHTML = '<use xlink:href="#brandLogo_gmx"></use>'
  }

  // special handling for host gmx.net but portal GMX AT
  const brandForLinks: BrandType = portal === 'gmxat' ? 'gmx.at' : brand
  const links = linksMap[brandForLinks]
  Object.entries(links).forEach(([key, val]) => {
    document.querySelector(`[data-replace-href=${key}]`).setAttribute('href', val)
  })
}
